import moment from 'moment';

export default (value, format = 'DD/MM/YYYY') => {
  return moment(value).format(format);
};
